import { useCallback, useState } from 'react';
import { FindAllQueryDto } from '../models';

type Pagination = { pageIndex: number; pageSize: number };

export type UseFindAllQueryReturnType<Entity extends object> = {
	query: FindAllQueryDto<Entity>;
	setPagination: (pagination: Pagination) => void;
	setSorting: (sorting: FindAllQueryDto<Entity>['sort']) => void;
	setFiltering: (filtering: FindAllQueryDto<Entity>['filter']) => void;
};

export const useFindAllQuery = <Entity extends object>(initial: FindAllQueryDto<Entity>): UseFindAllQueryReturnType<Entity> => {
	const [query, setQuery] = useState<FindAllQueryDto<Entity>>(initial || {});

	const setPagination = useCallback(
		(pagination: Pagination) => setQuery((q) => ({ ...q, page: pagination.pageIndex, pageSize: pagination.pageSize })),
		[setQuery],
	);

	const setSorting = useCallback(
		(sorting: FindAllQueryDto<Entity>['sort']) => setQuery((q) => ({ ...q, sort: sorting?.map((s) => ({ ...s })) })),
		[setQuery],
	);

	const setFiltering = useCallback(
		(filtering: FindAllQueryDto<Entity>['filter']) => setQuery((q) => ({ ...q, filter: filtering?.map((f) => ({ ...f })) })),
		[setQuery],
	);

	return { query, setPagination, setSorting, setFiltering };
};
